import _defineProperty from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import { generateTitle } from '@/utils/i18n';
import _variables from '@/styles/variables.scss';
import Item from "./Item";
import AppLink from "./Link";
export default {
  components: {
    SidebarItem: SidebarItem,
    Logo: Logo,
    Item: Item,
    AppLink: AppLink
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['permission_routes', 'sidebar', 'menuList'])), mapState({
    slideClass: function slideClass(state) {
      return state.settings.slideClass;
    },
    themeClass: function themeClass(state) {
      return state.settings.themeClass;
    },
    layoutType: function layoutType(state) {
      return state.settings.layoutType;
    }
  })), {}, {
    classObj: function classObj() {
      return _defineProperty(_defineProperty({}, this.slideClass, true), 'has-logo', this.showLogo);
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if (meta.activeMenu) {
      //   return meta.activeMenu
      // }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables;
    }
  }),
  methods: {
    generateTitle: generateTitle
  }
};